import React, {useState, useEffect} from 'react'

const RegisteredModal = props => { 

    const divStyle = { 
          display: props.displayModal ? 'block' : 'none'
     };
     function closeModal(e) {
        e.stopPropagation()
        props.closeModal()
     }

    return (
        <div className="modal" onClick={ closeModal } style={divStyle} >
            <div className="modal-content" onClick={ e => e.stopPropagation() }>
                
                <div className="modal-flex">
                    <div class="px-4">
                        <span className="close" onClick={ closeModal } >&times;</span>
                    </div>
                    <div class="px-2 w-full mx-auto text-center mb-10">
                        <h3>Thank you for signing up.</h3>
                        <h3>Stay tuned for updates!</h3>
                    </div>
                    
                    {/* <p>User type where this originated from: {props.usertype}</p> */}
                </div>
            </div>
        </div>
    );

}

export default RegisteredModal
